
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/productDetail/[name]",
      function () {
        return require("private-next-pages/productDetail/[name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/productDetail/[name]"])
      });
    }
  